module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "appendToBody": true,
      "zIndex": 1000000000
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal__d-calendar text-dark",
    class: {
      'd-modal__d-calendar--with-actions': _vm.isShowActions
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__d-calendar__header text-dark"
  }, [_c('h2', [_vm._v(_vm._s(_vm.calendar.name))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__d-calendar__content"
  }, [_c('div', {
    staticClass: "d-modal__d-calendar__container"
  }, [_c('DCalendar', {
    attrs: {
      "calendarId": _vm.calendar.id,
      "isShowWeek": false,
      "date": _vm.date,
      "events": _vm.events,
      "isLoadingEvents": _vm.isEventsLoading
    }
  })], 1), _vm._v(" "), (_vm.isShowActions) ? _c('CalendarViewDayRemoveOrReplace', {
    attrs: {
      "event": _vm.event,
      "calendar": _vm.calendar,
      "calendars": _vm.calendars
    },
    on: {
      "updateAndClose": function($event) {
        return _vm.$emit('updateAndClose')
      }
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64af2518!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarViewDay.vue
// module id = 1965
// module chunks = 1